<button (click)="rotateArrow()" mat-button="">
  <div class="flex align-itens-center justify-content-space-between btn-drop">
    <span>{{ title }}</span>
    <i #arrow="" class="ic-x-sm ic-arrow-down"></i>
  </div>
</button>
<ng-content></ng-content>
